import { render, staticRenderFns } from "./DrIndex.vue?vue&type=template&id=56b438f4&scoped=true&"
import script from "./DrIndex.vue?vue&type=script&lang=js&"
export * from "./DrIndex.vue?vue&type=script&lang=js&"
import style0 from "./DrIndex.vue?vue&type=style&index=0&id=56b438f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b438f4",
  null
  
)

export default component.exports